import { Button, Box, Heading } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ButtonStyled = styled(Button)`
  ${({ theme }) => css`
    margin-left: ${theme.spacings[400]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    height: ${theme.spacings[700]};
    width: auto;
    min-width: 100px;
    font-size: ${theme.fontSizes[300]};
    border-radius: ${theme.spacings[300]};
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 2px 1px -1px rgb(0 0 0 / 12%), 0 1px 1px 0 rgb(0 0 0 / 14%);
  `}
`;

export const ToolTipStyled = styled(Box).attrs({
  px: { sm: '500' },
  py: { sm: '400' },
})`
  ${({ theme }) =>
    css`
      background: ${theme.colors.grey[1000]};
      position: absolute;
      right: -140px;
      top: ${theme.spacings[100]};
      border-radius: ${theme.spacings[300]};
      font-size: ${theme.fontSizes[400]};
      &::after {
        content: '';
        width: 0;
        height: 0;
        border-top: ${theme.spacings[200]} solid transparent;
        border-bottom: ${theme.spacings[200]} solid transparent;
        border-right: ${theme.spacings[300]} solid ${theme.colors.grey[1000]};
        position: absolute;
        left: -${theme.spacings[300]};
        top: 10px;
      }
    `}
`;

export const HeadingStyled = styled(Heading).attrs({
  size: '400',
  color: 'grey.1000',
})`
  padding-top: ${({ theme }) => theme.spacings[100]};
  padding-bottom: ${({ theme }) => theme.spacings[100]};
  white-space: nowrap;
`;
export const BoxStyled = styled(Box).attrs({
  py: { sm: '300' },
  px: { sm: '500' },
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    width: 100%;
    border-bottom: 1px solid ${theme.colors.grey[400]};
  `}
`;
